import { Compiler, Component, NgModule, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModalService } from './common-modal.service';
import { SharedModule } from '../../shared.module';
import { CommonModalModel } from './common-modal.model';
import { ICommonModalData } from './common-modal.interface';
import { CommonModalTemplatesEnum } from './common-modal-templates.enum';
import { CommonModalDataService } from './common-modal-data.service';
import { hiddenElementSlideInOut } from '../animations/slides.animation';

declare const P4: any;
@Component({
  selector: 'common-modal-component',
  template: '<ng-template #container></ng-template>'
})
export class CommonModalComponent implements OnInit {
  @ViewChild('container', {read: ViewContainerRef, static: true}) container: ViewContainerRef;

  constructor(
    private compiler: Compiler,
    private commonModalService: CommonModalService,
    private commonModalDataService: CommonModalDataService,
  ) {
  }

  ngOnInit(): void {
    this.commonModalDataService.modalsObs$.subscribe(
      (commonModalModel: CommonModalModel) => {
        if (!commonModalModel) {
          return;
        }

        this.setModal(commonModalModel);
      }
    );
  }

  private setModal(commonModalModel: CommonModalModel): void {
    if (this.commonModalService.isTemplateDefined(commonModalModel.modalData.templateName)) {
      this.prepareTemplate(commonModalModel.modalData);

      return;
    }

    this.addComponent(commonModalModel);
  }

  private prepareTemplate(modalData: ICommonModalData): void {
    if (modalData) {
      setTimeout(() => {
        P4.modules.customModal.init();
        P4.modules.customModal.onShow(this.commonModalService.getId(modalData));

        if (typeof modalData.init === 'function') {
          modalData.init();
        }
      });
    }
  }

  private addComponent(modalDataModel: CommonModalModel): void {
    const self = this;

    @Component({
      template: self.commonModalService.getTemplate(modalDataModel.modalData),
      animations: [hiddenElementSlideInOut]
    })
    class TemplateComponent implements OnInit {
      public modalData: any;

      private templateName: CommonModalTemplatesEnum = modalDataModel.modalData.templateName;

      constructor(
        private parent: CommonModalComponent
      ) {
        this.modalData = null;
      }

      ngOnInit(): void {
        modalDataModel.modalObs$.subscribe(
          (data: ICommonModalData) => {
            if (!data) {
              return;
            }

            this.updateData(data);
          }
        );

        this.parent.prepareTemplate(modalDataModel.modalData);
      }

      private updateData(modalData: ICommonModalData): void {
        if (modalData.templateName !== this.templateName) {
          return;
        }

        this.modalData = modalData;
      }
    }

    @NgModule({imports: [FormsModule, ReactiveFormsModule, BrowserModule, SharedModule], declarations: [TemplateComponent]})
    class TemplateModule {
    }

    const module = this.compiler.compileModuleAndAllComponentsSync(TemplateModule);

    const factory = module.componentFactories.find((comp) =>
      comp.componentType === TemplateComponent
    );

    const component = this.container.createComponent(factory);

    this.commonModalService.addToInitializedModalsList(modalDataModel, component);
  }
}


